<template>
  <div class="drawer_wrapper">
    <div class="drawer_wrapper-body"><slot></slot></div>

    <div
      v-if="withFooter"
      class="drawer_wrapper-footer"
      :class="[{ 'footer-centered': footerCentered }]"
    >
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DrawerWrapper',

  props: {
    withFooter: {
      type: Boolean,
      default: false
    },
    footerCentered: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style lang="scss" scoped>
// 与 _hack.scss 中的变量值保持一致
$height-drawer-header: 46px;

.drawer_wrapper {
  height: calc(100vh - 46px);
  display: flex;
  flex-direction: column;

  &-body {
    flex-shrink: 0;
    padding: 20px;
    flex: 1;
    overflow: auto;
  }

  &-footer {
    flex-shrink: 0;
    height: 60px;
    border-top: 1px solid #f1f1f1;
  }
}

.footer-centered {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
